import { Component } from "react";

interface LoadingProps {
  loadingMessage?: string;
  show?: boolean;
}

export default class LoadingBox extends Component<LoadingProps> {
  public render() {
    const classes = `loading-showbox ${(this.props.show) ? "" : "loading-hidden"}`;

    return (
      <div className={classes}>
        <div className="loading-message">{this.props.loadingMessage ? this.props.loadingMessage : "Loading"}<span>.</span><span>.</span><span>.</span></div>
      </div>
    );
  }
}
